window.jQuery = window.$ = require('jquery');

require('./compat.js');
require('./vendor/jquery.smartbanner.js');

const pjax = require('./app/pjax');
const search = require('./app/search');
const payments = require('./app/payments');
const discussions = require('./app/discussions');
const adminDiscussions = require('./app/admin/discussions');
const registration = require('./app/registration');
const button_actions = require('./app/button_actions');
const slider = require('./app/slider');
const timeago = require('./app/timeago');
const image = require('./app/image');
const happenings = require('./app/happenings');
const thumbCenter = require('./app/thumbCenter');
const thumbHover = require('./app/thumbHover');
const modal = require('./app/modal');
const reactApp = require('./flux/app');
const tour = require('./app/tour');
const menu = require('./app/menu');
const mailee = require('./app/mailee');
const autohighlight = require('./app/autohighlight');
const highlighted = require('./app/highlighted');
const subscription = require('./app/subscription');
const vip = require('./app/vip');
const loginPopups = require('./app/loginPopups');
const updates = require('./app/updates');
const settings = require('./app/settings');
const popup = require('./app/popup');
const links = require('./app/links');
// const mask = require('./app/mask');
const campaigns = require('./app/campaigns');
const landing = require('./app/landing');
const questions = require('./app/questions');
const banners = require('./app/banners');
const callIfRouteMatch = require('./app/util.js').callIfRouteMatch;
const scrollTop = require('./app/scrollTop');
const form = require('./app/form');
const collapse = require('./app/collapse');

const initialized = {};

const get = require('lodash').get;

const app = {
  facebook_fix() {
    if (window.location.hash == '#_=_') {
      history.replaceState
        ? history.replaceState(null, null, window.location.href.split('#')[0])
        : window.location.hash = '';
    }
  },
  pjaxInit() {
    // popup.init();
    if (initialized.thumbCenter !== 1) {
      callIfRouteMatch('.*/(images|home).*', () => {
        initialized.thumbCenter = 1;
        thumbCenter.init();
      });
    }
    if (initialized.thumbHover !== 1) {
      callIfRouteMatch(".*images/(monitor|just_view|reported|approve_batch).*", function() {
        initialized.thumbHover = 1;
        thumbHover.init();
      });
    }
    if (initialized.search !== 1) {
      callIfRouteMatch('.*/search.*', () => {
        initialized.search = 1;
        search.init();
      });
    }
    if (initialized.discussions !== 1) {
      callIfRouteMatch('.*/(discussions|happenings).*', () => {
        initialized.discussions = 1;
        discussions.init();
      });
    }
    if (!get(globals, 'phalcon', false) && initialized.payments !== 1) {
      // TODO: pielikt precīzāku pārbaudi vai vajag payments init
      callIfRouteMatch(".*/payments.*", function() {
        initialized.payments = 1;
        payments.init();
        payments.initScrollHandler();
      });
    }
    if (initialized.questions !== 1) {
      initialized.questions = 1;
      questions.init();
    }

    scrollTop.init();
    image.init();
    /* if (!get(globals, 'phalcon', false)) {
      happenings.init();
    } */
    happenings.init();
    form.init();
  },
  adboxInit() {
    if (typeof inxBX == 'undefined' || inxBX == null) {
      return false;
    }
    var id = $('[data-adbox]').id;
    inxBX.placement({
      id: id,
      onEmissionEmpty: function () {
        $("#" + id).parent().hide();
      }
    }, 1);
  },
  initAppBanners() {
    var title = 'Otrapuse.lv';
    if (typeof domain !== 'undefined') {
      title = domain;
    }
    $.smartbanner({
      title: title,
      author: 'Hansa Interactive',
      daysHidden: 1, // Duration to hide the banner after being closed (0 = always show banner)
      hideOnInstall: false, // Hide the banner after "VIEW" is clicked.
      // Cookie gets saved anyway (even with 'hideOnInstall' set to 'false').
      // And banner is not hidden immediately, but after refreshing page, it will not be shown if "VIEW" was clicked.
      // So set this as well to 1 day (otherwise it will get saved for 3 months).
      daysReminder: 1, // Duration to hide the banner after "VIEW" is clicked *separate from when the close button is clicked* (0 = always show banner)
    });

    $('#smartbanner').css('position', 'fixed').css('top', 'auto').css('bottom', 0);

    $(document).on('click', '.sb-close', function() {
      $('#smartbanner').hide();
    });
  },
  init() {
    this.adboxInit();
    this.initAppBanners();
    this.facebook_fix();
    collapse.init();
    popup.init();
    reactApp.init();
    pjax.init();
    form.init();
    callIfRouteMatch('.*/(search|top).*', () => {
      initialized.search = 1;
      search.init();
    });
    callIfRouteMatch('.*/(discussions|happenings).*', () => {
      initialized.discussions = 1;
      discussions.init();
    });
    // TODO: pielikt precīzāku pārbaudi vai vajag payments init
    if (!get(globals, 'phalcon', false)) {
      callIfRouteMatch(".*/payments.*", function() {
        payments.init();
        payments.initScrollHandler();
        payments.handlePageLoad();
      });
    }
    callIfRouteMatch('.*/(register_step2|register_step3|external_register).*', () => {
      registration.init();
    });
    button_actions.init();
    slider.init();

    timeago.init('.timeago');
    image.init();
    /* if (!get(globals, 'phalcon', false)) {
      happenings.init();
    } */
    happenings.init();

    menu.init();
    autohighlight.init();
    highlighted.init();
    subscription.init();
    vip.init();

    if (window.location.pathname.indexOf('register_step') == -1) {
      $(document).ready(() => {
        loginPopups.init(tour.init);
      });
    }

    callIfRouteMatch('.*/(images|home).*', () => {
      initialized.thumbCenter = 1;
      thumbCenter.init();
    });

    callIfRouteMatch(".*images/(monitor|just_view|reported|approve_batch).*", function() {
      initialized.thumbHover = 1;
      thumbHover.init();
    });

    updates.init();
    updates.finishRequest();
    settings.init();
    links.init();
    // mask.init();
    campaigns.init();
    landing.init();

    callIfRouteMatch('.*/questions.*', () => {
      if (initialized.questions !== 1) {
        initialized.questions = 1;
        questions.init();
      }
    });
    banners.init();
    if (['mailee.otrapuse.lv', 'lindoamor.mail.ee'].indexOf(window.location.hostname) !== -1) {
      mailee.init(false);
    }

    scrollTop.init();
    initialized.scrollTop = 1;

    const _this = this;
    $(document).on('pjax:end', () => {
      // TODO Can check if other 'initialized' values needs to be reset.
      initialized.thumbCenter = 0;
      initialized.thumbHover = 0;
      _this.pjaxInit();
    });

    if (get(globals, 'mobile', false)) {
      // lai nelēkātu backgrounds
      const bg = $('.background');
      $(window).resize('resizeBackground');
      function resizeBackground() {
        bg.height($('body').height() + 200);
      }
      resizeBackground();
    }

    // Šo, iespējams, kaut kur jāpārvieto, bet pagaidām šāds variants darbojas
    $(document).on('click', '[data-admin-confirm]', function (e) {
      e.preventDefault();
      const msg = $(this).data('adminConfirm');
      popup.adminConfirmMessage(msg, $(this).attr('href'));
    });

    adminDiscussions.init();
  },
};

export default app;
